import { render, staticRenderFns } from "./PathwayCohortList.vue?vue&type=template&id=03b4f852&scoped=true&"
import script from "./PathwayCohortList.vue?vue&type=script&lang=js&"
export * from "./PathwayCohortList.vue?vue&type=script&lang=js&"
import style0 from "./PathwayCohortList.vue?vue&type=style&index=0&id=03b4f852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b4f852",
  null
  
)

export default component.exports